import { Module } from 'vuex';
import RootState from '../../state';
import { IRoleVO, ChildrenUserVO } from '@services/merchant/models';
import { IPoiSearchItem } from '@services/shop/settle.models';
interface IShopState {
    fromPage: string; // 从何处跳转认领页面来源
    userList: ChildrenUserVO[];
    userRoleList: IRoleVO[];
    pageParam: any;
    claimStep: number;
    shopClaimQuery: {
        keyWord: string;
        provinceAndCity: string[];
    };
    certId: string;
    commitTime: string;
    claimShopInfo: {
        // 认领后的poiId
        id: string;
        // 门店名字
        name: string;
        locationId: string;
        address: string;
        province: string;
        provinceCode: string;
        city: string;
        cityCode: string;
        lat: string;
        lng: string;
        district: string;
        // 行业
        category: string;
        // 行业code
        categoryCode: number;
    };
    claimShops: IPoiSearchItem[];
}

const initialState = {
    fromPage: '',
    userList: [],
    userRoleList: [],
    pageParam: {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
        sizes: [10, 20, 30, 40],
        isSearch: false,
        totalDisable: 0,
    },
    claimStep: 0,
    shopClaimQuery: {
        keyWord: '',
        provinceAndCity: [],
    },
    certId: '', // 提交资质成功后返回的资质id
    claimShopInfo: {
        // 认领后的poiId
        id: '',
        // 门店名字
        name: '',
        locationId: '',
        address: '',
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',
        lat: '',
        lng: '',
        district: '',
        // 行业
        category: '',
        // 行业code
        categoryCode: 0,
    },
};

const ShopStore: Module<IShopState, RootState> = {
    namespaced: true,
    state: {
        ...initialState,
    },
    mutations: {
        init(state: IShopState) {
            state = {
                ...initialState
            };
        },
        setFormPage(state: IShopState, data) {
            state.fromPage = data;
        },
        setUserRoleList(state: IShopState, data) {
            state.userRoleList = data;
        },
        setUserList(state: IShopState, data) {
            state.userList = data;
        },
        setPageParam(state: IShopState, data) {
            state.pageParam = {
                ...state.pageParam,
                ...data,
            };
        },
        setClaimStep(state: IShopState, data) {
            state.claimStep = data;
        },
        setShopClaimQuery(state: IShopState, data) {
            state.shopClaimQuery = data;
        },
        setClaimShopInfo(state: IShopState, data) {
            state.claimShopInfo = data;
        },
        // 清除认领门店选中的信息
        clearClaimShopInfo(state: IShopState) {
            state.claimShopInfo = initialState.claimShopInfo;
        },
        setClaimShops(state: IShopState, data) {
            state.claimShops = data;
        },
        setCertId(state: IShopState, data) {
            state.certId = data;
        },
    },
    actions: {
        async setUserRoleList({ commit }, payload) {
            commit('setUserRoleList', payload);
        },
        async setUserList({ commit }, payload) {
            commit('setUserList', payload);
        },
        async setPageParam({ commit }, payload) {
            commit('setPageParam', payload);
        },
        async setClaimStep({ commit }, payload) {
            commit('setClaimStep', payload);
        },
        async setShopClaimQuery({ commit }, payload) {
            commit('setShopClaimQuery', payload);
        },
        async setClaimShopInfo({ commit }, payload) {
            commit('setClaimShopInfo', payload);
        },
        async setClaimShops({ commit }, payload) {
            commit('setClaimShops', payload);
        },
        async setCertId({ commit }, payload) {
            commit('setCertId', payload);
        },
    },
    getters: {},
};

export default ShopStore;
